// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_AdjustResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Manual signed adjustment response — Full-gated.
 * Confirms the adjustment with the resulting balance.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_AdjustResponseDados {
franquia_id: number
request_id: string
signed_micro: number
balance_micro: number
ledger_id: number
}

export type AiCredits_AdjustResponse = ApiResponse<AiCredits_AdjustResponseDados>;

registerResponseContract('AiCredits_AdjustResponse', {
  franquia_id:   { type: 'number',  required: true },
  request_id:    { type: 'string',  required: true },
  signed_micro:  { type: 'number',  required: true },
  balance_micro: { type: 'number',  required: true },
  ledger_id:     { type: 'number',  required: true },
})
